import React, { memo } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@material-ui/core";

/**
 * Dialog for selecting permit issuance date before download
 * Used for both single and bulk permit downloads
 *
 * @component
 * @param {Object} props
 * @param {boolean} props.open - Whether the dialog is open
 * @param {string} props.selectedDate - Currently selected date (YYYY-MM-DD)
 * @param {Function} props.onDateChange - Callback when date changes
 * @param {Function} props.onClose - Callback to close dialog
 * @param {Function} props.onConfirm - Callback when user confirms download
 */
const IssuanceDateDialog = memo(
  ({ open, selectedDate, onDateChange, onClose, onConfirm }) => {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="xs">
        <DialogTitle>Select Permit Issuance Date</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Choose the date for the permit issuance line.
          </Typography>
          <TextField
            type="date"
            value={selectedDate}
            onChange={(e) => onDateChange(e.target.value)}
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            label="Issuance Date"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="default">
            Cancel
          </Button>
          <Button onClick={onConfirm} color="primary" variant="contained">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

IssuanceDateDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  selectedDate: PropTypes.string.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

IssuanceDateDialog.displayName = "IssuanceDateDialog";

export default IssuanceDateDialog;
